import styled from "styled-components";

export const Container = styled.div`
  height: auto;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};

  @media only screen and (max-width: 768px) {
    height: 50px;
  }
`;

export const TitleText = styled.div`
  font-family: "Lora medium";
  font-size: 35px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.darkGray2};
  letter-spacing: .55rem;
  text-align: center;

  @media only screen and (max-width: 768px) {
    font-size: 30px;
  }
`;
